import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from './components/NavBar';
import { Feature } from  './components/Feature';
import { About } from './components/About';


function App() {
  return (
    <div className="App">
        <NavBar></NavBar>
        <Feature></Feature>
        <About></About>
    </div>
  );
}

export default App;
